module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div style="text-align:left;width:500px">\r\n<b>Reason: </b>'+
((__t=( reason ))==null?'':__t)+
'<br>\r\n<b>Comment: </b>'+
((__t=( comment ))==null?'':__t)+
'<br>\r\n';
 if (hasAudits) { 
__p+='\r\n<b>Audits:</b><br>\r\n	<table class="table popoverTable"> \r\n	<thead>\r\n            <tr>\r\n                <th  id="auditUserDate">User</th>\r\n                <th  id="auditDate">Date</th>                \r\n                <th  id="auditComment">Comment</th>\r\n            </tr>            \r\n            </thead>           \r\n        <tbody name="audits-popover">           \r\n		</tbody>\r\n    </table>\r\n';
 } else {
__p+='\r\n<div name="audits-popover"></div>\r\n';
 }
__p+='\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/organizations/organization-patients-popover.html
// module id = 292
// module chunks = 0